import { render, staticRenderFns } from "./Wp_mini_guide_new_member.vue?vue&type=template&id=1f540d7b&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./Wp_mini_guide_new_member.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_guide_new_member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f540d7b",
  null
  
)

export default component.exports